import styled from 'styled-components';
import { Text } from '@rsos/base-components';
import { Button } from '@rsos/components/capstone/base';

export const CopyButton = styled(Button).attrs(() => ({
  btnType: 'secondary',
  size: 'xsmall',
  noMargin: true,
  justify: 'space-evenly',
  align: 'center',
  height: 'inherit',
}))`
  display: ${p => (p.hoverable ? 'none' : 'flex')};
  position: absolute;
  outline: none;
  border: none;
  right: 0;
  width: 70px;
  color: ${p =>
    p.copied ? p.theme.colors.primaryBase : p.theme.colors.secondaryText};
`;

export const CopyButtonText = styled(Text).attrs(() => ({
  pl: '5px',
}))`
  font-size: 9px; // the right size for the text to not wrap
`;
